export class MollieTerminalSettings {
	enabled:boolean = false;
	defaultTerminalId:string = "";

	public constructor(data?:any){
		if (!data) return;
		this.enabled = data.enabled || false;
		this.defaultTerminalId = data.defaultTerminalId || "";
	}

	public getJSON(){
		return {
			enabled: this.enabled,
			defaultTerminalId: this.defaultTerminalId
		};
	}
}
